<template>
    <div v-show="value" class="flex items-center flex-col justify-center overflow-hidden fixed inset-0 z-40">
        <div class="absolute inset-0 bg-gray-900 bg-opacity-80" @click="cancel"></div>

        <card-component
            v-show="value"
            :title="title"
            class="shadow-lg w-full max-h-modal md:w-3/5 lg:w-2/5 z-50"
            :header-icon="hasControl ? mdiClose : null"
            @header-icon-click="cancel"
        >
            <div class="space-y-3">
                <slot />
            </div>

            <divider />

            <jb-buttons v-if="hasControl">
                <jb-button :label="buttonLabel" :color="button" @click="confirm" />
                <jb-button v-if="hasCancel" :label="__('Cancel')" @click="cancel" :color="button" outline />
            </jb-buttons>
        </card-component>
    </div>
</template>

<script>
import { computed } from 'vue'
import JbButton from '@/Components/Dashboard/JbButton'
import JbButtons from '@/Components/Dashboard/JbButtons'
import CardComponent from '@/Components/Dashboard/CardComponent'
import Divider from '@/Components/Dashboard/Divider'
import {
    mdiClose
} from "@mdi/js";
import __ from '@/trans'

export default {
    name: 'TheModalBox',
    components: {
        JbButton,
        JbButtons,
        CardComponent,
        Divider
    },
    props: {
        title: String,
        button: {
            type: String,
            default: 'info'
        },
        buttonLabel: {
            type: String,
            default: __('Confirm')
        },
        hasCancel: Boolean,
        hasControl: {
          type: Boolean,
          default: true
        },
        modelValue: [String, Number, Boolean]
    },
    emits: ['update:modelValue', 'cancel', 'confirm'],
    setup (props, { emit }) {
        const value = computed({
            get: () => props.modelValue,
            set: value => emit('update:modelValue', value)
        })

        const confirmCancel = mode => {
            value.value = false
            emit(mode)
        }

        const confirm = () => confirmCancel('confirm')

        const cancel = () => {
          if(props.hasControl) {
            confirmCancel('cancel')
          }
        }

        return {
            mdiClose,
            value,
            confirm,
            cancel
        }
    }
}
</script>
